import { IConverseApis } from "./IConverseApis"
import ApiUtils from "../ApiUtils"
import { RoomEvents } from "../../containers/HMSVideoCall/helper"

const ConverseUrls = {
	publishRoomMetrics: "/v1/metric",
}
export default class ConverseApis implements IConverseApis {
	getServiceUrl = (url: string) => "/converse" + url
	publishRoomMetrics = (payload: RoomEvents): Promise<void> => {
		return ApiUtils.post(this.getServiceUrl(ConverseUrls.publishRoomMetrics), payload)
	}
}
